export default __webpack_public_path__ + "static/media/bullet.abf0bc5b.png";